import React from "react";
import Margin from "../../Margin";
import Loader from "Components/Loader/loader";
import PropTypes from "prop-types";
import { connect } from "react-redux";

/**
 * Composant MatomoModule sert à afficher les widgets de la partie Matomo
 * à l'aide de l'api de l'outil éponyme ainsi que d'un package prévu à cet effet
 *
 * Les widgets importés viennent directement du dashboard Matomo visible
 * sur la page d'administration de celui-ci.
 *
 * {@link useMatomo} est un hook permettant de récupérer des fonctions
 * de Matomo qui vont fournir des statistiques sur l'utilisateur
 * ou le visiteur actuel aux administrateurs et/ou personnes authorisées
 *
 */
const MatomoModule = ({ auth }) => {
  const MATOMO_WIDGET_TOKEN = process.env.REACT_APP_MATOMO_WIDGET_TOKEN;

  const [widgetUrl, setWidgetUrl] = React.useState("");
  const [idSite, setIdSite] = React.useState(0);

  /**
   * Fonction permettant d'assigner un ID de site matomo grâce slug
   * de l'université connectée
   *
   * @param {String} slug - Slug de l'université connectée
   * @returns {Number} - ID du site matomo
   */
  const assignIdSite = (slug) => {
    if (!slug) return 0;
    else
      switch (slug) {
        //? P1
        case "pantheon-sorbonne":
          return 1;
        //? P2
        case "uspn":
          return 2;
        case "assas":
          return 3;
        //? P12
        case "upec":
          return 4;
        //? P3
        case "sorbonne-nouvelle":
          return 5;
        default:
          return 0;
      }
  };

  /**
   * On assigne l'id du site matomo grâce à redux
   */
  React.useEffect(() => {
    if (auth.universityConnected) {
      setIdSite(assignIdSite(auth.universityConnected?.slug));
    }
  }, [auth]);

  /**
   * On assigne l'url du widget matomo grâce à l'id du site matomo
   * et le token d'authentification
   */
  React.useEffect(() => {
    if (MATOMO_WIDGET_TOKEN && idSite !== 0)
      setWidgetUrl(
        `https://matomo.reseaupro.unif.fr//index.php?module=Widgetize&action=iframe&moduleToWidgetize=Dashboard&actionToWidgetize=index&idSite=${idSite}&period=week&date=yesterday&token_auth=${MATOMO_WIDGET_TOKEN}`
      );
  }, [MATOMO_WIDGET_TOKEN, idSite]);

  return (
    <div className="stats_container">
      <div className="stats_container__iframe">
        {MATOMO_WIDGET_TOKEN ? (
          <iframe
            src={widgetUrl}
            frameBorder="0"
            marginHeight="0"
            marginWidth="0"
            width="100%"
            height="100%"
          ></iframe>
        ) : (
          <Loader />
        )}
      </div>
      <Margin position="bottom" size="s" />
    </div>
  );
};

MatomoModule.propTypes = {
  //? Redux states
  auth: PropTypes.array,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(MatomoModule);
